'use client';

import MetaTags from '@/components/meta-tag/meta-tag';
import dynamic from 'next/dynamic';

const UsaHeader = dynamic(() => import('@/components/usa-header'));
const UsaHero = dynamic(() => import('@/components/lets-meet-usa/usa-hero'));
const UsaAiEngineering = dynamic(() => import('@/components/lets-meet-usa/usa-ai-engineering'));
const UsaMeetingRightForYou = dynamic(() => import('@/components/lets-meet-usa/usa-meeting-right-for-you'));
const UsaWorkTogether = dynamic(() => import('@/components/lets-meet-usa/usa-work-together'));
const UsaClientTrust = dynamic(() => import('@/components/lets-meet-usa/usa-client-trust'));
const UsaEngageAfter = dynamic(() => import('@/components/lets-meet-usa/usa-engage-after'));
const UsaMeetDeep = dynamic(() => import('@/components/lets-meet-usa/usa-meet-deep'));
const UsaRequestMeeting = dynamic(() => import('@/components/lets-meet-usa/usa-request-meeting'));
const Footer = dynamic(() => import('@/components/footer'));

const Page = () => {
    return (
        <>
            <MetaTags />
            <div className="dark:bg-black">
                {/* Custom Header for this page */}
                <UsaHeader />

                {/* 1. Hero Section */}
                <UsaHero />

                {/* 2. AI Engineering Section */}
                <UsaAiEngineering />

                {/* 3. Is This Meeting Right for You? */}
                <UsaMeetingRightForYou />

                {/* 4. What Can We Work On Together? */}
                <UsaWorkTogether />

                {/* 5. Why 500+ Global Clients Trust Moweb */}
                <UsaClientTrust />

                {/* 6. How We Can Engage After the USA Meeting */}
                <UsaEngageAfter />

                {/* 7. Meet Deep Trivedi */}
                <UsaMeetDeep />

                {/* 8. Request 1:1 Meeting */}
                <UsaRequestMeeting />

                {/* Footer */}
                <Footer />
            </div>
        </>
    );
};

export default Page;
